"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _immer = _interopRequireDefault(require("immer"));

var _reactInfiniteScroller = _interopRequireDefault(require("react-infinite-scroller"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _MediaImage = _interopRequireDefault(require("./MediaImage"));

var _utils = require("../utils");

var _actions = require("../actions");

var _store = require("../store");

var _theme = require("../theme");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var MediaLibrary = function MediaLibrary(props) {
  var onSelect = props.onSelect,
      allow = props.allow,
      multiple = props.multiple,
      _props$selected = props.selected,
      defaultSelected = _props$selected === void 0 ? [] : _props$selected;

  var _ref2 = (0, _store.useStore)(),
      _ref3 = _slicedToArray(_ref2, 2),
      _ref3$ = _ref3[0],
      config = _ref3$.config,
      siteID = _ref3$.cmsState.siteID,
      dispatch = _ref3[1];

  var _ref4 = (0, _react.useState)(null),
      _ref5 = _slicedToArray(_ref4, 2),
      page = _ref5[0],
      setPage = _ref5[1];

  var _ref6 = (0, _react.useState)([]),
      _ref7 = _slicedToArray(_ref6, 2),
      items = _ref7[0],
      setItems = _ref7[1];

  var _ref8 = (0, _react.useState)(null),
      _ref9 = _slicedToArray(_ref8, 2),
      activeFile = _ref9[0],
      setActiveFile = _ref9[1];

  var _ref10 = (0, _react.useState)(false),
      _ref11 = _slicedToArray(_ref10, 2),
      uploader = _ref11[0],
      setUploader = _ref11[1];

  var _ref12 = (0, _react.useState)(false),
      _ref13 = _slicedToArray(_ref12, 2),
      loading = _ref13[0],
      setLoading = _ref13[1];

  var _ref14 = (0, _react.useState)(defaultSelected),
      _ref15 = _slicedToArray(_ref14, 2),
      selected = _ref15[0],
      setSelected = _ref15[1];

  var activeFileIndex = activeFile && items.findIndex(function (o) {
    return o.id === activeFile.id;
  });
  (0, _react.useEffect)(function () {
    // We need to add this check, because deployment causes a new site fetch
    if (page === null) {
      loadMediaItems(page || 0);
    }
  }, [page]);

  var loadMediaItems = /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(page) {
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(page > -1)) {
                _context.next = 5;
                break;
              }

              _context.next = 3;
              return _actions.mediaActions.getMediaItems({
                siteID: siteID,
                page: page,
                limit: 24
              }, dispatch, config);

            case 3:
              result = _context.sent;

              if (result) {
                setItems(function (items) {
                  return items.concat(result.items);
                });
                setPage(result.page);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadMediaItems(_x) {
      return _ref16.apply(this, arguments);
    };
  }();

  var handleLoadMore = function handleLoadMore() {
    return page && loadMediaItems(page);
  };

  var handleUpdateMediaItem = /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(mediaItem) {
      var id, altText, siteID, result;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              id = mediaItem.id, altText = mediaItem.altText, siteID = mediaItem.siteID;
              _context2.next = 3;
              return _actions.mediaActions.updateMediaItem({
                id: id,
                altText: altText,
                siteID: siteID
              }, dispatch, config);

            case 3:
              result = _context2.sent;

              if (result) {
                setItems(function (items) {
                  return items.map(function (o) {
                    return o.id === result.id ? result : o;
                  });
                });

                _antd.message.success("Saved successfully.");
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleUpdateMediaItem(_x2) {
      return _ref17.apply(this, arguments);
    };
  }();

  var handlDeleteMediaItem = /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var result;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _actions.mediaActions.deleteMediaItem(_objectSpread(_objectSpread({}, activeFile), {}, {
                siteID: siteID
              }), dispatch, config);

            case 2:
              result = _context3.sent;

              if (result) {
                setItems(function (items) {
                  return items.filter(function (o) {
                    return o.id !== parseInt(result);
                  });
                });
                handleCloseDialog();

                _antd.message.success("Deleted successfully.");
              }

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handlDeleteMediaItem() {
      return _ref18.apply(this, arguments);
    };
  }();

  var handleFileUpload = /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(info) {
      var _info$file, status, name, originFileObj, error, result;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _info$file = info.file, status = _info$file.status, name = _info$file.name, originFileObj = _info$file.originFileObj, error = _info$file.error;

              if (!(status !== 'uploading')) {
                _context4.next = 7;
                break;
              }

              setLoading(true);
              _context4.next = 5;
              return _actions.mediaActions.uploadMediaItem({
                siteID: siteID,
                file: originFileObj
              }, dispatch, config);

            case 5:
              result = _context4.sent;

              if (result) {
                setItems(function (items) {
                  return [result].concat(_toConsumableArray(items));
                });
              }

            case 7:
              if (status === 'done') {
                _antd.message.success("".concat(name, " file uploaded successfully."));

                setLoading(false);
              } else if (status === 'error') {
                // TODO: length computable is set to false and therefore throwing an error if file size is too big.
                // However, this has nothing to do with the actual file upload to the backend, so we not gonna display an error here.
                // But this should be fixed at some point.
                if (!(error !== null && error !== void 0 && error.lengthComputable)) {
                  _antd.message.success("".concat(name, " file uploaded successfully."));
                } else {
                  console.log(info);

                  _antd.message.error("".concat(name, " file upload failed."));
                }

                setLoading(false);
              }

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleFileUpload(_x3) {
      return _ref19.apply(this, arguments);
    };
  }();

  var handleCloseDialog = function handleCloseDialog() {
    setActiveFile(null);
  };

  var handleClickCheckbox = function handleClickCheckbox(image) {
    var nextSelection = (0, _immer.default)(selected, function (draft) {
      var index = selected.findIndex(function (o) {
        return o.id === image.id;
      });

      if (index > -1) {
        draft.splice(index, 1);
      } else {
        draft.push(image);
      }

      return draft;
    });
    setSelected(nextSelection);
  };

  var handleSelect = function handleSelect(item) {
    if (multiple) {
      handleClickCheckbox(item);
      setActiveFile(null);
    } else {
      dispatch({
        type: 'CLOSE_DIALOG'
      });
      onSelect && onSelect(item);
    }
  };

  var handleSelectMultiple = function handleSelectMultiple() {
    dispatch({
      type: 'CLOSE_DIALOG'
    });
    onSelect && onSelect(selected);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Container, {
    actionBar: multiple && selected.length > 0
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.UploadOutlined, null),
    children: "Upload",
    type: "primary",
    onClick: function onClick() {
      return setUploader(!uploader);
    },
    loading: loading
  }), uploader && /*#__PURE__*/_react.default.createElement(_antd.Upload.Dragger, {
    name: "file",
    multiple: true,
    onChange: handleFileUpload,
    showUploadList: false
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "ant-upload-drag-icon"
  }, /*#__PURE__*/_react.default.createElement(_icons.InboxOutlined, null)), /*#__PURE__*/_react.default.createElement("p", {
    className: "ant-upload-text"
  }, "Click or drag file to this area to upload")), /*#__PURE__*/_react.default.createElement(MediaItems, null, /*#__PURE__*/_react.default.createElement(_reactInfiniteScroller.default, {
    pageStart: 0,
    loadMore: handleLoadMore,
    hasMore: page > -1,
    loader: /*#__PURE__*/_react.default.createElement(LoadingContainer, {
      key: 0
    }, /*#__PURE__*/_react.default.createElement(_antd.Spin, {
      size: "large"
    }))
  }, items && items.filter(function (o) {
    return allow ? allow.includes(o.type) : o;
  }).map(function (o) {
    return /*#__PURE__*/_react.default.createElement(MediaItem, {
      key: o.id
    }, /*#__PURE__*/_react.default.createElement(MediaItemInner, {
      onClick: function onClick() {
        return setActiveFile(o);
      }
    }, (0, _utils.renderImage)(o)), multiple && /*#__PURE__*/_react.default.createElement(CheckboxContainer, {
      onClick: function onClick() {
        return handleClickCheckbox(o);
      }
    }, /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
      checked: !!selected.find(function (p) {
        return p.id === o.id;
      })
    })));
  }), /*#__PURE__*/_react.default.createElement(DummyItem, null), /*#__PURE__*/_react.default.createElement(DummyItem, null), /*#__PURE__*/_react.default.createElement(DummyItem, null), /*#__PURE__*/_react.default.createElement(DummyItem, null), /*#__PURE__*/_react.default.createElement(DummyItem, null))), multiple && selected.length > 0 && /*#__PURE__*/_react.default.createElement(ActionBar, null, "".concat(selected.length, " selected"), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    onClick: handleSelectMultiple,
    children: "Select",
    type: "primary"
  })))), !!activeFile && /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    transitionName: "none",
    maskTransitionName: "none",
    title: "Media Image",
    visible: true,
    onCancel: handleCloseDialog,
    footer: null,
    width: 1024
  }, /*#__PURE__*/_react.default.createElement(PrevButton, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.ArrowLeftOutlined, null),
    onClick: function onClick() {
      return setActiveFile(items[activeFileIndex - 1]);
    },
    disabled: activeFileIndex === 0
  })), /*#__PURE__*/_react.default.createElement(_MediaImage.default, {
    file: activeFile,
    onSelect: onSelect && handleSelect,
    onDelete: handlDeleteMediaItem,
    onUpdate: handleUpdateMediaItem
  }), /*#__PURE__*/_react.default.createElement(NextButton, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.ArrowRightOutlined, null),
    onClick: function onClick() {
      return setActiveFile(items[activeFileIndex + 1]);
    },
    disabled: activeFileIndex === items.length - 1
  }))));
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  padding-bottom: ", ";\n"])), function (_ref) {
  var actionBar = _ref.actionBar;
  return actionBar ? '40px' : 0;
});

var MediaItems = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  > div {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n"])));

var MediaItem = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  float: left;\n  position: relative;\n  height: 140px;\n  width: 140px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n  cursor: pointer;\n  background: #fff;\n  border: 1px solid #d9d9d9;\n"])));

var MediaItemInner = _styledComponents.default.div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .gatsby-image-wrapper {\n    max-width: 100%;\n    max-height: 100%;\n  }\n"])));

var CheckboxContainer = _styledComponents.default.div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  top: 4px;\n  right: 6px;\n  z-index: 1;\n  padding: 4px;\n"])));

var DummyItem = _styledComponents.default.div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  height: 0;\n  width: 140px;\n"])));

var LoadingContainer = _styledComponents.default.div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n"])));

var ActionBar = _styledComponents.default.div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  background: #fff;\n  border-top: 1px solid ", ";\n"])), _theme.colors.tertiary);

var PrevButton = _styledComponents.default.div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  z-index: 1;\n  top: 12px;\n  right: 100px;\n"])));

var NextButton = _styledComponents.default.div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  z-index: 1;\n  top: 12px;\n  right: 60px;\n"])));

var _default = MediaLibrary;
exports.default = _default;